export default "__VITE_ASSET__Kdk7pAFU__"